import { render, staticRenderFns } from "./BookingChannelsView.vue?vue&type=template&id=7dbd84bf&scoped=true&"
import script from "./BookingChannelsView.vue?vue&type=script&lang=js&"
export * from "./BookingChannelsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd84bf",
  null
  
)

export default component.exports